module.exports = __webpack_public_path__ + "media/components/country-flag/static/si-26de410799d153fce1eade6714b1d6ce.svg";